import echarts from 'echarts/lib/echarts'
import { token, chartPalette } from '@/plugins/theme'

// Thème ECharts « walden » bâti sur les tokens du design system : séries chart-1 à chart-5,
// grille chart-grid, texte ink / ink-muted, fond transparent. Les valeurs sont lues au moment
// de l'enregistrement (tokens.css est chargé avant ce module par main.js).

const axisStyle = () => ({
  axisLine: { show: true, lineStyle: { color: token('chart-grid') } },
  axisTick: { show: false, lineStyle: { color: token('chart-grid') } },
  axisLabel: { show: true, textStyle: { color: token('ink-muted') } },
  splitLine: { show: true, lineStyle: { color: [token('chart-grid')] } },
  splitArea: { show: false, areaStyle: { color: [token('surface-sunken'), 'transparent'] } }
})

const seriesBorder = () => ({
  itemStyle: {
    normal: { borderWidth: 2, borderColor: token('surface-raised') },
    emphasis: { borderWidth: 2, borderColor: token('surface-raised') }
  }
})

const waldenTheme = () => ({
  color: chartPalette(),
  backgroundColor: 'transparent',
  textStyle: { color: token('ink') },
  title: {
    textStyle: { color: token('ink') },
    subtextStyle: { color: token('ink-muted') }
  },
  line: {
    itemStyle: { normal: { borderWidth: 2 } },
    lineStyle: { normal: { width: 3 } },
    symbolSize: 8,
    symbol: 'emptyCircle',
    smooth: false
  },
  bar: {
    itemStyle: {
      normal: { barBorderWidth: 2, barBorderColor: token('surface-raised') },
      emphasis: { barBorderWidth: 2, barBorderColor: token('surface-raised') }
    }
  },
  pie: seriesBorder(),
  scatter: seriesBorder(),
  funnel: seriesBorder(),
  gauge: seriesBorder(),
  categoryAxis: axisStyle(),
  valueAxis: axisStyle(),
  logAxis: axisStyle(),
  timeAxis: axisStyle(),
  toolbox: {
    iconStyle: {
      normal: { borderColor: token('ink-muted') },
      emphasis: { borderColor: token('ink') }
    }
  },
  legend: { textStyle: { color: token('ink-muted') } },
  tooltip: {
    axisPointer: {
      lineStyle: { color: token('chart-grid'), width: 1 },
      crossStyle: { color: token('chart-grid'), width: 1 }
    }
  },
  visualMap: { color: [token('chart-5'), token('chart-1')] },
  dataZoom: {
    backgroundColor: 'transparent',
    dataBackgroundColor: token('surface-sunken'),
    fillerColor: token('brand-soft'),
    handleColor: token('line-strong'),
    handleSize: '100%',
    textStyle: { color: token('ink-muted') }
  }
})

export const registerWaldenTheme = () => echarts.registerTheme('walden', waldenTheme())

registerWaldenTheme()

// Le métier (data-activity) et le thème (data-theme) changent les tokens : on réenregistre le thème
// pour que les graphiques créés ensuite prennent la bonne palette.
new MutationObserver(registerWaldenTheme)
  .observe(document.documentElement, { attributes: true, attributeFilter: ['data-activity', 'data-theme'] })
